module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Voucher")]), _vm._v(" "), _c('span', {}, [_c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "to": "/paymentvoucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Payment")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "to": "/receiptvoucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Receipt")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "to": "/contravoucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Contra")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "to": "/journalvoucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Journal")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "content1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.branches,
      "label": "name",
      "name": "branch",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        return _vm.loadBranchData()
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.branchLedgers,
      "label": "name",
      "name": "ledger",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        return _vm.changeFilter()
      }
    },
    model: {
      value: (_vm.filter.branchLedger),
      callback: function($$v) {
        _vm.$set(_vm.filter, "branchLedger", $$v)
      },
      expression: "filter.branchLedger"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.voucherType),
      expression: "filter.voucherType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "voucher",
      "placeholder": "Voucher Type"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "voucherType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Voucher")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "payment"
    }
  }, [_vm._v("Payment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "receipt"
    }
  }, [_vm._v("Receipt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "journal"
    }
  }, [_vm._v("Journal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "contra"
    }
  }, [_vm._v("Contra")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.startDate),
      expression: "filter.startDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "startdate"
    },
    domProps: {
      "value": (_vm.filter.startDate)
    },
    on: {
      "change": function($event) {
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "startDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.endDate),
      expression: "filter.endDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "enddate"
    },
    domProps: {
      "value": (_vm.filter.endDate)
    },
    on: {
      "change": function($event) {
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "endDate", $event.target.value)
      }
    }
  })]), _vm._v("\r\n        ."), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ledgers")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [(_vm.canAccess('voucher-create')) ? _c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "v-if": _vm.filter.branchLedger,
      "href": ((this.$axios.defaults.baseURL) + "/voucher/export/excel?branch_id=" + (_vm.branch.id) + "&branch_ledger_id=" + (_vm.filter.branchLedger.id) + "&all=all")
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download Excel\r\n      ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('voucher-create')) ? _c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "v-if": _vm.filter.branchLedger,
      "href": ((this.$axios.defaults.baseURL) + "/financialstatement/export/excel?branch_id=" + (_vm.branch.id) + "&branch_ledger_id=" + (_vm.filter.branchLedger.id) + "&all=all")
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download Financial Statement\r\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('section', {
    staticClass: "content",
    attrs: {
      "id": "print"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.filter.branchLedger) ? _c('div', {
    staticClass: "col-md-12 bg-green"
  }, [_c('center', [_c('strong', [_vm._v(_vm._s(_vm.filter.branchLedger.name))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "background-color": "#FFFFD9"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 4) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 4)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 4))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 7)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 4)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 4))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-striped table-responsive"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "background-color": "#c5c9cc8f"
    }
  }, [_vm._l((_vm.ledgerItems), function(row, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.drAmt > 0 || row.crAmt > 0),
        expression: "row.drAmt > 0 || row.crAmt > 0"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s((index - 1) + (_vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.voucherNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.voucherType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ledger.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.drAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.crAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((row.balance).toFixed(2)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group",
      attrs: {
        "role": "group",
        "aria-label": "..."
      }
    }, [_c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#showVoucharModal"
      },
      on: {
        "click": function($event) {
          return _vm.showVoucher(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), (!row.disbursementId) ? _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteVoucher(row.voucherId)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _vm._v(" "), (!row.disbursementId) ? _c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#editVoucharModal"
      },
      on: {
        "click": function($event) {
          return _vm.editVoucher(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "label-success"
  }, [_c('strong', [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("DR")]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s((_vm.drTotalAmt).toFixed(2)))])])]), _vm._v(" "), _c('td', {
    staticClass: "label-info"
  }, [_c('strong', [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("CR")]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s((_vm.crTotalAmt).toFixed(2)))])])]), _vm._v(" "), _c('td', {
    staticClass: "label-primary"
  }, [_c('strong', [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.balanceType))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s((_vm.totalBalanceAmt).toFixed(2)))])])]), _vm._v(" "), _c('td')])], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 4) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 4)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 4))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 7)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 4)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 4))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])]) : _vm._e()])]), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "showVoucharModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modalLabelSmall",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row label-primary"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm.voucher.date))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.voucher.voucherNo))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_vm._v("Voucher Type:")]), _vm._v(" " + _vm._s(_vm.voucher.voucherType))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(6), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table "
  }, [_vm._l((_vm.voucher.dr_ledger), function(dledger, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(dledger.ledger.name))]), _vm._v(" "), _c('td', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(dledger.amt))])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('th', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("Dr:" + _vm._s(_vm.voucher_sum(_vm.voucher.dr_ledger)))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(7), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table "
  }, [_vm._l((_vm.voucher.cr_ledger), function(cledger, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(cledger.ledger.name))]), _vm._v(" "), _c('td', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(cledger.amt))])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('th', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("Cr:" + _vm._s(_vm.voucher_sum(_vm.voucher.cr_ledger)))])])])], 2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('strong', [_vm._v("Narration:")]), _vm._v(" " + _vm._s(_vm.voucher.narration))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editVoucharModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modalLabelSmall",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row label-primary"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm.voucher.date))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.voucher.voucherNo))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_vm._v("Voucher Type:")]), _vm._v(" " + _vm._s(_vm.voucher.voucherType))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(9), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table "
  }, [_vm._l((_vm.voucher.dr_ledger), function(dledger, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(dledger.ledger.name))]), _vm._v(" "), _c('td', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(dledger.amt))])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('th', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("Dr:" + _vm._s(_vm.voucher_sum(_vm.voucher.dr_ledger)))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(10), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table "
  }, [_vm._l((_vm.voucher.cr_ledger), function(cledger, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(cledger.ledger.name))]), _vm._v(" "), _c('td', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(cledger.amt))])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('th', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("Cr:" + _vm._s(_vm.voucher_sum(_vm.voucher.cr_ledger)))])])])], 2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('strong', [_vm._v("Narration:")]), _vm._v(" " + _vm._s(_vm.voucher.narration))])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 bg-green"
  }, [_c('center', [_c('strong', [_vm._v("Voucher Entry Update")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "background-color": "#FFFFD9"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "options": _vm.branchLedgers,
      "label": "name",
      "name": "dr_ledger",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.dr_ledger),
      callback: function($$v) {
        _vm.dr_ledger = $$v
      },
      expression: "dr_ledger"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "dr_ledger"
    }
  })], 1), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.date),
      expression: "form.date"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('date')
    },
    attrs: {
      "type": "date",
      "name": "date"
    },
    domProps: {
      "value": (_vm.form.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.holdTempVoucher()
      }
    }
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "options": _vm.branchLedgers,
      "label": "name",
      "name": "cr_ledger",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.cr_ledger),
      callback: function($$v) {
        _vm.cr_ledger = $$v
      },
      expression: "cr_ledger"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "cr_ledger"
    }
  })], 1), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amt),
      expression: "amt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "amt",
      "step": ".01"
    },
    domProps: {
      "value": (_vm.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1), _vm._v(" "), _vm._m(15)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(16), _vm._v(" "), _c('tbody', [_vm._l((_vm.holdVouchers), function(ledger, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\r\n                                      " + _vm._s(ledger.branchLedger.name) + "\r\n                                      "), _c('br'), _c('i', [_vm._v("Cur Bal:"), _c('strong', [_vm._v(_vm._s(ledger.branchLedger.balanceAmt) + " " + _vm._s((ledger.branchLedger.balanceAmt >= 0) ? 'Dr' : 'Cr'))])])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(ledger.amt))]), _vm._v(" "), _c('a', {
      staticClass: "text-danger",
      on: {
        "click": function($event) {
          return _vm.removeHoldVoucher(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('hr'), _c('strong', [_vm._v("Total: " + _vm._s(this.total))]), _c('hr'), _c('hr')])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.narration),
      expression: "form.narration"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.form.narration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "narration", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "~click": function($event) {
        return _vm.createVoucher()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('hr')])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2",
      "width": "5%"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "width": "15%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "width": "10%"
    }
  }, [_vm._v("VoucherNo")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "width": "10%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "width": "25%"
    }
  }, [_vm._v("Particular")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3",
      "width": "30%"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "width": "5%"
    }
  }, [_vm._v("View")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Dr.")]), _vm._v(" "), _c('th', [_vm._v("Cr.")]), _vm._v(" "), _c('th', [_vm._v("Balance")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header label-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalLabelSmall"
    }
  }, [_vm._v("Voucher")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-default"
  }, [_c('strong', [_vm._v("DR Ledger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-default"
  }, [_c('strong', [_vm._v("CR Ledger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header label-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalLabelSmall"
    }
  }, [_vm._v("Voucher")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-default"
  }, [_c('strong', [_vm._v("DR Ledger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-default"
  }, [_c('strong', [_vm._v("CR Ledger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Dr. Acc "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Cr. Acc "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Amt "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "title": "Submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "80%"
    }
  }, [_vm._v("Particular")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Amount (Cr)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ad69fc24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/accounting/Voucher.vue
// module id = 891
// module chunks = 0